import { ItemCondition } from '@cod-monorepo/interfaces';

export const ItemConditionMapping: { [key in ItemCondition]: string } = {
    [ItemCondition.BROKEN]: 'Broken',
    [ItemCondition.CRUSHED]: 'Crushed',
    [ItemCondition.FROZEN]: 'Frozen',
    [ItemCondition.LEAKING]: 'Leaking',
    [ItemCondition.STAINED]: 'Stained',
    [ItemCondition.THAWED]: 'Thawed',
    [ItemCondition.TORN]: 'Torn',
    [ItemCondition.WARM]: 'Warm',
    [ItemCondition.WET]: 'Wet',
    [ItemCondition.DAMAGED_LABEL]: 'Damaged Label',
    [ItemCondition.CUT]: 'Cut'
};
